import Vue from 'vue';
import Vuex from "vuex";
import callParkings from "./modules/callParkings";
import details from "./modules/details";
import wallboard from "./modules/wallboard";

Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
        callParkings,
        details,
        wallboard
    },
    state: {
        alertMessages: [],
        captchaKey: '',
        isLoading: true,
        isLogged: false
    },
    getters: {
        alertMessages: (state) => {
            return state.alertMessages
        },
        captchaKey: (state) => {
            return state.captchaKey
        },
        isLoading: (state) => {
            return state.isLoading
        },
        isLoggedIn: (state) => {
            return state.isLogged;
        }
    },
    mutations: {
        addAlertMessage: (state, message) => {
            state.alertMessages.push(message)
        },
        deleteAlertMessage: (state, index) => {
            state.alertMessages.splice(index, 1);
        },
        setCaptchaKey: (state, captchaKey) => {
            state.captchaKey = captchaKey;
        },
        setIsLoading: (state, loading) => {
            state.isLoading = loading;
        },
        updateIsLogged: (state, isLogged) => {
            state.isLogged = isLogged;
        }
    },
    actions: {
        createAlertMessage: (context, message) => {
            context.commit('addAlertMessage', message)
        },
        removeAlertMessage: (context, {index, autoRemove}) => {
            const alert = context.getters.alertMessages[index];
            if (alert && (!alert.notHide || !autoRemove)) {
                context.commit('deleteAlertMessage', index);
            }
        },
        updateCaptchaKey: (context, captchaKey) => {
            context.commit('setCaptchaKey', captchaKey);
        },
        changeIsLogged: (context, isLogged) => {
            context.commit('updateIsLogged', isLogged);
        },
        changeIsLoading: (context, loading) => {
            context.commit('setIsLoading', loading)
        }
    }
});